import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { API_URL } from '../config';
import './Settings.css';

function Settings() {
  const [settings, setSettings] = useState({
    homepage_news_count: 6
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const { getAuthHeader } = useAuth();

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API_URL}/settings`, {
        headers: getAuthHeader()
      });
      if (response.data) {
        setSettings(response.data);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching settings:', error);
      // If settings don't exist yet, use defaults
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings({
      ...settings,
      [name]: parseInt(value) || 0
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      await axios.post(`${API_URL}/settings`, settings, {
        headers: getAuthHeader()
      });
      toast.success('Settings saved successfully');
    } catch (error) {
      console.error('Error saving settings:', error);
      toast.error('Failed to save settings');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading settings...</div>;
  }

  return (
    <div className="settings main-content">
      <div className="container">
        <h1 className="page-title">Configurations</h1>

        <div className="settings-card">
          <h2>Homepage Settings</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="homepage_news_count">
                Number of News Posts in Homepage Carousel
              </label>
              <input
                type="number"
                id="homepage_news_count"
                name="homepage_news_count"
                value={settings.homepage_news_count}
                onChange={handleChange}
                min="1"
                max="20"
                required
              />
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-primary" disabled={saving}>
                {saving ? 'Saving...' : 'Save Settings'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Settings;